
import Vue from 'vue'
import Router from 'vue-router'
import Auth from '@okta/okta-vue'

import HomeComponent from './../components/Home.vue'

import Login from './../components/login/index.vue' 

import Index from './../components/index.vue'


import ManagementComponent from './../components/management/index.vue'


import SiteList from './../components/management/site/index.vue'
import SiteDetails from './../components/management/site/SiteDetails.vue'


import PageList from './../components/management/site/page/index.vue'
import PageDetails from './../components/management/site/page/PageDetails.vue'

import PageGeneral from './../components/management/site/page/general/index.vue'
import PagePlacements from './../components/management/site/page/placements/index.vue'
import PageTag from './../components/management/site/page/tag/index.vue'

import DisplayList from './../components/management/site/page/placements/list/index.vue'
import PageTypeParameters from './../components/management/site/page/placements/parameters/index.vue'

import Mapping from './../components/mapping/index.vue'
import Reporting from './../components/reporting/index.vue'

import sampleConfig from './../config'

Vue.use(Router)
Vue.use(Auth, sampleConfig.oidc)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      component: Login,
      name : 'login'
     
    },
    {
      path: '/implicit/callback',
      component: Auth.handleCallback(),
    },
    {
      path: '/',
      component: Index,
      meta: { requiresAuth: true },
      children : [
        { path: '', component: Reporting, alias: 'reporting'},
        {
          path: 'management', 
          component: ManagementComponent, 
          children: [
            { path : '', component : SiteList, name: 'siteList'},
            { path: 'site/new', component: SiteDetails, name: 'siteNew'},
            { path : ':siteId/details', component: SiteDetails, props: true, name: 'siteDetails'},
            { path : ':siteId/pages', component : PageList, name : 'pageList', props: true},
            { path : ':siteId/page/new', component : PageDetails, name : 'pageNew', props: (route) => ({pageId: 'new', siteId: route.params.siteId})},
            { path : 'page/:pageId', component : PageDetails, props: true,
              children: [
                { path: '', component: PageGeneral, name : 'pageDetails'},
                { path: 'general', component: PageGeneral, name: 'pageGeneral'},
                { path: 'tag', component: PageTag, name: 'pageTag'},
                { path: 'placements', component: PagePlacements, 
                  children: [
                    { path: '', component: DisplayList, name : 'PagePlacements' },
                    { path: 'list', component: DisplayList, name : 'PlacementsList' },
                    { path: 'parameters', component: PageTypeParameters, name : 'PageTypeParameters' }
                  ]
                }
              ]
            }
          ]
        },
        { path: 'reporting', component: Reporting},
        { path: 'mapping', component: Mapping, rops: { mappingType: 'inventory'}},
        { path: 'mapping/inventory', component: Mapping, props: { mappingType: 'inventory'}},
        { path: 'mapping/order', component: Mapping, props: { mappingType: 'order'}},
      ]
    },
    { path : '*', component: HomeComponent},

  ]
})

const onAuthRequired = async (from, to, next) => {
  if (from.matched.some(record => record.meta.requiresAuth) && !(await Vue.prototype.$auth.isAuthenticated())) {
    console.log("Unidentified")
    // Navigate to custom login page
    next({name: 'login'})
  } else {
    next()
  }
}

router.beforeEach(onAuthRequired)

export default router